// Both URL shapes need their own names: Router 4 removes an earlier route when
// another route registers the same name.
export default function getEntryDetailPageChildren(namePrefix = 'blogEntryDetailPage-') {
    return [
        {
            name: namePrefix + 'comments',
            path: 'comments',
            component: () => import(/* webpackChunkName: "diary" */ './BlogEntryDetailPageComments'),
            props: true,
            meta: {name: 'comments', entryNamePrefix: namePrefix}
        },
        {
            name: namePrefix + 'info',
            path: 'detail',
            component: () => import(/* webpackChunkName: "diary" */ './BlogEntryDetailPageInfo'),
            props: true,
            meta: {name: 'info', entryNamePrefix: namePrefix}
        },
    ];
}

export const entryRouteNames = {
    methods: {
        entryRouteName(name) {
            return this.$route.meta.entryNamePrefix + name;
        },
    },
};
